// Loaded from the bundle instead of index.html, so that the "default" trusted types policy
// already exists when CookieYes assigns script URLs and HTML
const COOKIEYES_SCRIPT = "https://cdn-cookieyes.com/client_data/9afb36c91eed9abff212e77c/script.js";

if (typeof document !== "undefined") {
  const script = document.createElement("script");
  script.id = "cookieyes";
  script.src = COOKIEYES_SCRIPT;
  document.head.appendChild(script);
}
